export enum Gender {
    M = 1,
    F = 2,
    All = 3
}

export const individualGenders = (Object.values(Gender).filter((v) => !isNaN(Number(v))) as number[]).filter(_ => _ !== Gender.All);
export const groupGenders = Object.values(Gender).filter((v) => !isNaN(Number(v))) as number[];